import React from 'react';

import { Card, Tabs } from 'antd';

import { getCurrentUser } from '../services/authService';
import IndividualUsers from '../components/users/IndividualUsers';
import BusinessUsers from '../components/users/BusinessUsers';
import AdminUsers from '../components/users/AdminUsers';
import AdminApiKeys from '../components/users/AdminApiKeys';
import InviteManagement from '../components/users/InviteManagement';
import UserRequestsList from '../components/user-requests/UserRequestsList';
import { useRootStore } from '@/store/root-store';
import { RenderIf } from '@/components/RenderIf';
import { doesUserHaveAccess } from '@/utils/permissions';
import { PERMISSION_NAMES } from '@/constants/permissions';
import '../assets/styles/users.css';

const { TabPane } = Tabs;

const Users = () => {
    try {
        const currentUser = getCurrentUser();

        const { permissions, isUserSuperAdmin, roles } = useRootStore();

        // Check if user has admin access - with proper fallbacks
        const hasAdminAccess = isUserSuperAdmin || 
            (Array.isArray(permissions) && permissions.length > 0 && 
             doesUserHaveAccess(permissions, PERMISSION_NAMES.GET_ADMIN_USERS));

    return (
        <div style={{ padding: '24px' }}>
            <Card>
                <Tabs
                    defaultActiveKey="individuals"
                    size="large"
                >
                    <TabPane
                        tab="Personal Customers"
                        key="individuals"
                    >
                        <IndividualUsers currentUser={currentUser} />
                    </TabPane>
                    <TabPane
                        tab="Business Customers"
                        key="business"
                    >
                        <BusinessUsers currentUser={currentUser} />
                    </TabPane>

                    {hasAdminAccess && (
                        <>
                            <TabPane
                                tab="API Keys"
                                key="api-keys"
                            >
                                <AdminApiKeys />
                            </TabPane>
                            <TabPane
                                tab="Admin Users"
                                key="admins"
                            >
                                <AdminUsers currentUser={currentUser} />
                            </TabPane>
                            <TabPane
                                tab="Create Users"
                                key="invites"
                            >
                                <InviteManagement />
                            </TabPane>
                        </>
                    )}
                    
                    <TabPane
                        tab="Upgrade Requests"
                        key="upgrade-requests"
                    >
                        <UserRequestsList />
                    </TabPane>
                </Tabs>
            </Card>
        </div>
    );
    } catch (error) {
        console.error('Error in Users component:', error);
        return (
            <div style={{ padding: '24px' }}>
                <Card title="Error">
                    <p>Something went wrong loading the Users page.</p>
                    <p>Error: {error?.message || 'Unknown error'}</p>
                </Card>
            </div>
        );
    }
};

export default Users;
